const _ = require('lodash');

const findCustomers = (data, availableAccessorialRates) => {
  const foundCustomers = availableAccessorialRates.filter(
    (customer) => customer.customer === (data.id ? data.id : data._id),
  );
  return foundCustomers;
};

const customerNameMap = {
  admin: (userData) => `${userData.first_name} ${userData.last_name}`,
  carrier: (userData) => userData.name,
  shipper: (userData) => userData.company_name,
};

const mapCustomerData = (data, customer) => {
  const customerData = { ...customer };
  const customerType = data._type?.toLowerCase();
  customerData.customerEmail = data.email;
  customerData.customerType = customerType;
  customerData.name = customerNameMap[customerType](data);
  return customerData;
};

const customerDataMapper = (data, availableAccessorialRates) => {
  const foundCustomers = findCustomers(data, availableAccessorialRates);

  const customers = foundCustomers.map((customer) => {
    return mapCustomerData(data, customer);
  });

  return customers;
};

const accessorialRatesFilesMapper = (customers, customerData) => {
  const mappedData = {};
  customers.forEach((accessorialRate) => {
    if (!mappedData[accessorialRate.customer]) {
      mappedData[accessorialRate.customer] = {
        accessorialRates: [accessorialRate],
        files: [],
      };
    } else {
      mappedData[accessorialRate.customer].accessorialRates.push(
        accessorialRate,
      );
    }
  });
  const customerIds = Object.keys(mappedData);
  customerIds.forEach((customerId) => {
    mappedData[customerId].files = customerData.find(
      (customer) => customer.customer === customerId,
    ).files;
  });
  return mappedData;
};

module.exports = {
  customerDataMapper,
  accessorialRatesFilesMapper,
};
